import { Files } from '../../../lib/constants/files'
import { CenterGroupDocumentInput } from '../../../lib/types/models/center-group/center-group-input'
import { FileInput } from '../../../lib/types/models/file/file-input'
import { uploadFile } from '../../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export async function createCenterGroupDocument(
  input: {
    centerId: number
    groupId: number
  } & CenterGroupDocumentInput
) {
  const { centerId, groupId, documents } = input

  let uploadedFiles: FileInput[] = []
  if (documents?.length) {
    uploadedFiles = (await Promise.all(
      documents.map((file) => (file ? uploadFile(Files.CENTER_GROUP_DOCUMENT, file) : null))
    ).then((files) => files.filter((file) => file !== null))) as FileInput[]
  }

  return restApiClient
    .url(constructApiUrl(API.centers.uploadCenterGroupDocument.url, { id: centerId, groupId }))
    .post<CenterGroupDocumentInput>({ documents: uploadedFiles })
}
